import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import Tooltip from '@mui/material/Tooltip';
import { Scheduling_JobStatus } from '@tyro/api';
import { useTranslation } from '@tyro/i18n';
import { InfoCircleIcon } from '@tyro/icons';

interface TaskStatusChipProps {
  status: Scheduling_JobStatus;
  exceptionMessage?: string | null;
}

const statusColorMap: Record<
  Scheduling_JobStatus,
  'default' | 'info' | 'success' | 'error' | 'warning'
> = {
  [Scheduling_JobStatus.Queued]: 'default',
  [Scheduling_JobStatus.Pending]: 'default',
  [Scheduling_JobStatus.Running]: 'info',
  [Scheduling_JobStatus.Success]: 'success',
  [Scheduling_JobStatus.Failed]: 'error',
  [Scheduling_JobStatus.PartialSuccess]: 'warning',
  [Scheduling_JobStatus.Cancelled]: 'default',
};

function getChipIcon(
  status: Scheduling_JobStatus,
  exceptionMessage?: string | null,
) {
  if (status === Scheduling_JobStatus.Running) {
    return <CircularProgress size={14} color="inherit" />;
  }
  if (exceptionMessage) {
    return <InfoCircleIcon sx={{ fontSize: 16 }} />;
  }
  return undefined;
}

export function TaskStatusChip({
  status,
  exceptionMessage,
}: TaskStatusChipProps) {
  const { t } = useTranslation(['common']);

  const chip = (
    <Chip
      label={t(`common:backgroundTasks.status.${status}`)}
      color={statusColorMap[status]}
      size="small"
      variant="soft"
      icon={getChipIcon(status, exceptionMessage)}
    />
  );

  if (exceptionMessage) {
    return <Tooltip title={exceptionMessage}>{chip}</Tooltip>;
  }

  return chip;
}
